module.exports = __webpack_public_path__ + "img/coin.165e4728.svg";